// extracted by mini-css-extract-plugin
module.exports = {"markdown":"MarkdownContent_markdown__1McD3"};